import React, { useState, useEffect } from 'react';
import question_data from '../../utils/data';

const QuestionJump = ({ currentQuestion, storeAnswers }) => {
    const [defaultSet, setDefaultSet] = useState(false);
    const questions = question_data;

    useEffect(() => {
        if (defaultSet === false) {
            storeAnswers(
                0,
                {
                    text: '',
                    eligible: true,
                    nextQuestion: currentQuestion + 1,
                },
                currentQuestion
            );

            setDefaultSet(true);
        }
    }, [defaultSet, currentQuestion, storeAnswers]);

    const handleOnChange = (event) => {
        storeAnswers(
            0,
            {
                text: event.nativeEvent.target.options[event.nativeEvent.target.selectedIndex].text,
                eligible: true,
                nextQuestion: event.target.value ? parseInt(event.target.value) : currentQuestion + 1,
            },
            currentQuestion
        );
    };

    return (
        <>
            <select onChange={handleOnChange}>
                <option value=''>Select Eligibility Criteria</option>
                {Object.entries(questions).map((question, idx) => {
                    const optionText = question[1].questionAlt ? question[1].questionAlt : question[1].question;

                    return question[1].stage === 2 && question[1].type !== 'question_jump' ? (
                        <option key={idx} value={question[0]}>
                            {optionText}
                        </option>
                    ) : (
                        ''
                    );
                })}
            </select>
        </>
    );
};

export default QuestionJump;
